import { render, staticRenderFns } from "./UploadStockRequestModal.vue?vue&type=template&id=43537870"
import script from "./UploadStockRequestModal.vue?vue&type=script&lang=js"
export * from "./UploadStockRequestModal.vue?vue&type=script&lang=js"
import style0 from "./UploadStockRequestModal.vue?vue&type=style&index=0&id=43537870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports